import { SpecializationDto } from '@apiModels/SpecializationDto.csharp';
import React, { FC } from 'react'
import { useInsuranceLabels } from '../Utils/Context/labelsContext';
import { FeaturedSpecializations } from './FeaturedSpecializations';
import { SpecializationsCombobox } from './SpecializationsCombobox';

interface SpecializationsContainerProps {
  specializations: SpecializationDto[];
  featuredSpecializations: SpecializationDto[]
}


export const SpecializationsContainer: FC<SpecializationsContainerProps> = (props) => {
  const { featuredSpecializations, specializations } = props;
  const {
    headings
  } = useInsuranceLabels();

  return (
    <div className="specializationsContainer">
      <h1 className="specializationsContainer__heading">
        {headings.findSpecializationHeading}
      </h1>
      <div className="specializationsContainer__dropdown">
        <SpecializationsCombobox
          specializations={specializations}
        />
      </div>
      <div className="specializationsContainer__featured">
        {featuredSpecializations && featuredSpecializations.length > 0 && (
          <FeaturedSpecializations
            specializations={featuredSpecializations}
          />
        )}
      </div>
    </div>
  )
};
